<template>
    <Popup v-model="protocolShow" class="protocol-popup" @click-overlay="protocolBack" closeable round>
        <div v-html="contentWithHtml" class="protocol-popup-content"/>
        <div style="padding:10px 30px;">
            <Button round type="info" size="large" color="linear-gradient(to right, #05b3fd, #495bff)"
                    @click="signProtocol">同意并继续
            </Button>
        </div>
    </Popup>
</template>

<script>
    import {Button, Popup} from 'vant';

    export default {
        components: {Popup, Button},
        data() {
            return {
                contentWithHtml: "",
                protocolShow: false
            }
        },
        mounted() {
            // this.protocol();
        },
        methods: {
            protocol() {
                this.$http.tokiot.sys.protocol.lastVersionProtocol({}).then(ret => {
                    if (ret) {
                        const {contentWithHtml} = ret
                        this.contentWithHtml = contentWithHtml
                        this.protocolShow = true
                    }
                })
            },
            signProtocol() {
                this.$http.tokiot.sys.protocol.signProtocol({})
                    .then(ret => {
                        if (ret) {
                            this.protocolShow = false;
                        }
                    })
            },
            protocolBack() {
                this.protocolShow = false;
            },
        },
    }
</script>

<style lang="less" scoped>
    .protocol-popup {
        height: calc(90vh - 20px);
        width: calc(90vw - 20px);
    }

    .protocol-popup-content {
        margin-top: 15px;
        padding: 10px;
        overflow: auto;
        height: calc(100% - 105px);
    }

</style>

